import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        field: String,
        tab: String,
    };

    static targets = [
        'prioritiesTab',
        'pricingTab'
    ];

    connect() {
        // Listen for custom events
        this.element.addEventListener('refresh-priority-tab', () => this.refreshPriorityTab());

        this.element.addEventListener('refresh-pricing-tab', () => this.refreshPricingTabAndPriorityTab());
    }

    disconnect() {
        this.element.removeEventListener('refresh-priority-tab', () => this.refreshPriorityTab());

        this.element.removeEventListener('refresh-pricing-tab', () => this.refreshPricingTabAndPriorityTab());
    }

    async refreshPriorityTab() {
        showPreloader();
        await $.get(routes['app_profile_refreshprioritiestab'], {}, (response) => {
            this.prioritiesTabTarget.innerHTML = response.html;
            this.syncPrioritiesAccordionHeader();
        });

        hidePreloader();
    }

    async refreshPricingTabAndPriorityTab() {
        await $.get(routes['app_profile_refreshpricingtab'], {}, (response) => {
            this.pricingTabTarget.innerHTML = response.html;
        });

        // Here we also will refresh the priority tab because of the price changes
        await $.get(routes['app_profile_refreshprioritiestab'], {}, (response) => {
            this.prioritiesTabTarget.innerHTML = response.html;
            this.syncPrioritiesAccordionHeader();
        });
    }

    // DDT-3885: the mobile accordion header sits outside the refreshed markup, so
    // mirror the remaining-priorities count into it — otherwise it keeps showing a
    // stale count (and its red "still to complete" highlight) until a page reload.
    syncPrioritiesAccordionHeader() {
        const toggle = document.querySelector('.profile-accordion-toggle--priorities');

        if (null === toggle) {
            return;
        }

        const count = toggle.querySelector('.profile-accordion-count');
        const rocket = toggle.querySelector('.profile-accordion-rocket');

        if (null === count || null === rocket) {
            return;
        }

        // _priority_tab.html.twig renders #priorities-badge only while fields are
        // still missing, so its presence is what "not complete yet" means here.
        const badge = this.prioritiesTabTarget.querySelector('#priorities-badge');
        const isComplete = null === badge;

        if (!isComplete) {
            count.textContent = badge.textContent.trim();
        }

        count.hidden = isComplete;
        rocket.hidden = !isComplete;

        toggle.classList.toggle('profile-accordion-toggle--todo', !isComplete);
        toggle.classList.toggle('profile-accordion-toggle--done', isComplete);
    }
}
